import { css } from "@emotion/react";

export const main = css`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const stepperWrapper = css`
  margin: 0.5rem 0 2.5rem;
  width: 16rem;
`;

export const description = css`
  text-align: center;
`;
